export default __webpack_public_path__ + "static/media/buildings&birds.bf11baa0.jpg";